import { render, staticRenderFns } from "./PartnerProjects.vue?vue&type=template&id=8c58911c&scoped=true"
import script from "./PartnerProjects.vue?vue&type=script&lang=js"
export * from "./PartnerProjects.vue?vue&type=script&lang=js"
import style0 from "./PartnerProjects.vue?vue&type=style&index=0&id=8c58911c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c58911c",
  null
  
)

export default component.exports